import React from "react";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";
import Autocomplete from "@mui/material/Autocomplete";
import { MenuItem } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import MuiTextField from "@mui/material/TextField";
import { TextField } from "formik-material-ui";
import { Field } from "formik";
import RichTextEditor from "../Common/RichTextEditor";
import SelectBox from "./SelectBox";

const useStyles = () => ({
  container: {
    display: "flex",
    margin: "16px 0",
    '&:hover button': {
      display: 'block !important'
    }
  },
  typography: {
    flex: 2,
    marginRight: '5px'
  },
  field: {
    flex: 7,
    marginRight: "12px",
  },
  actions: {
    flex: 2,
  },
  formBtn: {
    display: 'none !important'
  }
});

function InputElement(props) {
  const { classes, title } = props;

  return (
    <div className={classes.container}>
      <Typography
        className={classes.typography}
        gutterBottom
        variant="span"
        component="span"
      >
        {title}
      </Typography>
      <div className={classes.field}>{getInputComponent(props)}</div>
      <div className={classes.actions}>
        {!props.disableButton && (
          <LoadingButton
            className={classes.formBtn}
            variant="contained"
            color="primary"
            loading={Boolean(props.saving)}
            disabled={Boolean(props.saving)}
            onClick={(e) => props.onSaveClick(e, props.name)}
          >
            Save
          </LoadingButton>
        )}
      </div>
    </div>
  );
}

const getInputComponent = (props) => {
  switch (props.type) {
    case "textfield":
      return (
        <Field
          component={TextField}
          fullWidth
          size="small"
          {...props}
          type={"text"}
        />
      );
    case "textarea":
      return (
        <Field
          component={TextField}
          fullWidth
          size="large"
          {...props}
          type={"textarea"}
        />
      );
    case "richText":
      return <RichTextEditor {...props} />;
    case "datetime-local":
      return (
        <Field
          {...props}
          component={TextField}
          type="time"
          sx={{ width: "100%" }}
        />
      );
    case "checkbox":
      return (
        <Field style={{ width: '30px', height: '30px' }} name={props.name} type="checkbox" />
      )
    case "dropdown":
      return (
        <Field component={TextField} select fullWidth size="small" {...props}>
          {props.list && props.list.length > 0 ? (
            props.list.map((option) => (
              <MenuItem
                key={option.id}
                value={option.id}
                disabled={option.disabled}
              >
                {option.name}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>No options available</MenuItem>
          )}
        </Field>
      );
    case "product_books":
      return (
        <Field name={props.name}>
          {({ field, form }) => (
            <Autocomplete
              multiple
              disableClearable={true}
              disableCloseOnSelect
              filterSelectedOptions
              options={props.options || []}
              getOptionLabel={(option) => option.name}
              // convert field.value (array of ids) into option objects
              value={
                (props.options || []).filter((opt) =>
                  (field.value || []).includes(String(opt.id))
                )
              }
              onChange={(_, newValue) => {
                // store only ids in formik state
                form.setFieldValue(
                  field.name,
                  newValue.map((opt) => String(opt.id))
                );
              }}
              renderInput={(params) => (
                <MuiTextField
                  {...params}
                  variant="outlined"
                  size="small"
                  label={props.label || "Select books"}
                  placeholder="Choose books"
                />
              )}
            />
          )}
        </Field>
      );
    case "foodconsideration":
      return (
        <>
          <div className="food-consideration-section">
            <SelectBox
              multiple={false}
              name="person_food_considerations_1"
              type="type1_food"
              label="Select Type"
              labelId="select-type"
              options={props.options}
            />
            <SelectBox
              multiple={true}
              name="person_food_considerations_2"
              type="type2_food"
              label="Select Allergy"
              labelId="select-allergy"
              options={props.options}
              onChange={props.onChange}
            />
          </div>
          {
            props.formData && props.formData.person_food_considerations_2.filter((item) => item === 16).length ? (
              <Field
                component="textarea"
                fullWidth
                rows="5"
                size="large"
                name="person_food_considerations_other"
                style={{ width: '100%', padding: '10px', fontSize: '16px', borderColor: "#c4c4c4", borderRadius: '5px' }}
                placeholder="Please write other allergies"
              />
            ) : (
              <></>
            )
          }

        </>
      );
    default:
      return <Field component={TextField} fullWidth size="small" {...props} />;
  }
};

export default withStyles(useStyles)(InputElement);
